module.exports = __webpack_public_path__ + "assets/img/companyicon2.4be237fa.jpg";